import type { TMetroIcon } from 'shared/constants/buildingLabels';

import base from './icons/base.svg';
import ekb from './icons/ekb.svg';
import kaz from './icons/kaz.svg';
import msk from './icons/msk.svg';
import nn from './icons/nn.svg';
import nsk from './icons/nsk.svg';
import sam from './icons/sam.svg';
import spb from './icons/spb.svg';
import style from './style.css';

export interface IMetroIconProps {
  icon: TMetroIcon;
  /** Цвет линии метро */
  color: string | null;
}

/** Иконки метро по городам — из `business_shopping_centers/common/includes/icon_metro.html` монолита */
const ICONS: Record<TMetroIcon, string> = { base, msk, spb, ekb, kaz, nsk, nn, sam };

/**
 * SVG в JSX запрещён линтером, а цвет линии в `<img>` не передать,
 * поэтому иконка — маска, закрашенная цветом линии
 */
export const MetroIcon = ({ icon, color }: IMetroIconProps) => {
  const mask = `url("${ICONS[icon]}")`;

  return (
    <span
      className={style['container']}
      data-name="MetroIcon"
      aria-hidden="true"
      style={{ maskImage: mask, WebkitMaskImage: mask, ...(color && { backgroundColor: color }) }}
    />
  );
};
